<template>
  <SsoLogin v-if="useSSO" />
  <LoggedOutForm v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAuthenticationStore } from "@/stores/authentication";
import SsoLogin from "@/views/login-view/SsoLogin.vue";
import LoggedOutForm from "@/views/login-view/LoggedOutForm.vue";

const authStore = useAuthenticationStore();

const useSSO = computed(() => authStore.useSSO);
</script>
